(ns practitest.frontend.login.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub ::step         (fn [db _] (get-in db [:login :step] :email)))
(re-frame/reg-sub ::email        (fn [db _] (get-in db [:login :email] "")))
(re-frame/reg-sub ::error        (fn [db _] (get-in db [:login :error])))
(re-frame/reg-sub ::loading?     (fn [db _] (get-in db [:login :loading?] false)))
(re-frame/reg-sub ::forgot-password-sent? (fn [db _] (get-in db [:login :forgot-password-sent?] false)))
(re-frame/reg-sub ::cognito-enabled?    (fn [db _] (get-in db [:options :cognito-enabled])))
(re-frame/reg-sub ::cognito-google-url  (fn [db _] (get-in db [:options :cognito-google-url])))
(re-frame/reg-sub ::other-datacenters  (fn [db _] (get-in db [:login :other-datacenters] [])))
(re-frame/reg-sub ::login-image-urls   (fn [db _] (get-in db [:options :login-image-urls])))
(re-frame/reg-sub ::reset-code         (fn [db _] (get-in db [:login :reset-code])))
